import { Phone } from "lucide-react";

export default function FloatingCallButton() {
  return (
    <a
      href="tel:9014061803"
      data-testid="floating-call-btn"
      className="fixed bottom-6 right-6 z-50 lg:hidden flex items-center gap-2 bg-brand text-white px-5 py-4 shadow-lg hover:bg-brand-hover transition-colors print:hidden"
      aria-label="Call Mid America Star Builders"
    >
      <Phone className="w-5 h-5 animate-pulse" />
      <span className="font-outfit font-bold text-sm uppercase tracking-wider">Call Now</span>
    </a>
  );
}
